import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  chartsRow: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: designTokens.spacing[6],
  },
});
